var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyncIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1598 3.33332V1.84165C10.1598 1.46665 9.70983 1.28332 9.4515 1.54998L7.11816 3.87498C6.9515 4.04165 6.9515 4.29998 7.11816 4.46665L9.44316 6.79165C9.70983 7.04998 10.1598 6.86665 10.1598 6.49165V4.99998C12.9182 4.99998 15.1598 7.24165 15.1598 9.99998C15.1598 10.6583 15.0348 11.3 14.7932 11.875C14.6682 12.175 14.7598 12.5167 14.9848 12.7417C15.4098 13.1667 16.1265 13.0167 16.3515 12.4583C16.6598 11.7 16.8265 10.8667 16.8265 9.99998C16.8265 6.31665 13.8432 3.33332 10.1598 3.33332ZM10.1598 15C7.4015 15 5.15983 12.7583 5.15983 9.99998C5.15983 9.34165 5.28483 8.69998 5.5265 8.12498C5.6515 7.82498 5.55983 7.48332 5.33483 7.25832C4.90983 6.83332 4.19316 6.98332 3.96816 7.54165C3.65983 8.29998 3.49316 9.13332 3.49316 9.99998C3.49316 13.6833 6.4765 16.6667 10.1598 16.6667V18.1583C10.1598 18.5333 10.6098 18.7167 10.8682 18.45L13.1932 16.125C13.3598 15.9583 13.3598 15.7 13.1932 15.5333L10.8682 13.2083C10.6098 12.95 10.1598 13.1333 10.1598 13.5083V15Z",
    fill: "#065A15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncIconSmall);
export default __webpack_public_path__ + "static/media/sync-icon-small.b8f869d30b5932d2bbbb812073c57fe0.svg";
export { ForwardRef as ReactComponent };